export class PostWinningNumber{
    constructor(
        public merchantCode: String = '', 
        public lotteryTypeId: String = '', 
        public winningNumber: String = '', 
        public lotteryDate: String = '',
        public isMegaEnabled: String = '',
    ){}
}